(() => {
  class CareersOpenRoles {
    constructor(section) {
      this.section = section;
      this.filterButtons = Array.from(
        this.section.querySelectorAll('[data-careers-filter]')
      );
      this.jobs = Array.from(this.section.querySelectorAll('[data-careers-job]'));
      this.countEl = this.section.querySelector('[data-careers-count]');
      this.countLabelEl = this.section.querySelector('[data-careers-count-label]');
      this.emptyEl = this.section.querySelector('[data-careers-empty]');
      this.accordions = Array.from(
        this.section.querySelectorAll('[data-careers-accordion]')
      );

      this.activeFilters = {
        function: 'all',
        location: 'all'
      };

      this.mobileMedia = window.matchMedia('(max-width: 749px)');

      this.resizeTimer = null;

      this.handleMediaChange = this.handleMediaChange.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.init();
    }

    init() {
      this.bindFilters();
      this.bindAccordions();
      this.setupAccordions();

      if (this.mobileMedia.addEventListener) {
        this.mobileMedia.addEventListener('change', this.handleMediaChange);
      } else {
        this.mobileMedia.addListener(this.handleMediaChange);
      }

      window.addEventListener('resize', this.handleResize);
      window.addEventListener('orientationchange', this.handleResize);
      window.addEventListener('load', this.handleResize);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          this.refreshOpenAccordions();
        });
      }

      this.applyFilters();
    }

    bindFilters() {
      this.filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const filterType = button.dataset.filterType;
          const filterValue = button.dataset.filterValue;

          if (!filterType || !filterValue) return;

          this.activeFilters[filterType] = filterValue;
          this.updateActiveButtons(filterType, filterValue);
          this.applyFilters();
          this.refreshOpenAccordions();
        });
      });
    }

    updateActiveButtons(filterType, filterValue) {
      this.filterButtons.forEach((button) => {
        if (button.dataset.filterType !== filterType) return;

        const isActive = button.dataset.filterValue === filterValue;

        button.classList.toggle('CareersOpenRoles__pill--active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    applyFilters() {
      let visibleCount = 0;

      this.jobs.forEach((job) => {
        const jobFunction = job.dataset.function || '';
        const jobLocation = job.dataset.location || '';

        const matchesFunction =
          this.activeFilters.function === 'all' ||
          jobFunction === this.activeFilters.function;

        const matchesLocation =
          this.activeFilters.location === 'all' ||
          jobLocation === this.activeFilters.location;

        const shouldShow = matchesFunction && matchesLocation;

        job.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.updateCount(visibleCount);
      this.updateEmptyState(visibleCount);
    }

    updateCount(count) {
      if (this.countEl) {
        this.countEl.textContent = count;
      }

      if (this.countLabelEl) {
        this.countLabelEl.textContent = count === 1 ? 'OPEN ROLE' : 'OPEN ROLES';
      }
    }

    updateEmptyState(count) {
      if (!this.emptyEl) return;

      this.emptyEl.hidden = count !== 0;
    }

    bindAccordions() {
      this.accordions.forEach((accordion) => {
        const toggle = accordion.querySelector('[data-careers-accordion-toggle]');

        if (!toggle) return;

        toggle.addEventListener('click', () => {
          if (!this.mobileMedia.matches) return;

          const isOpen = accordion.classList.contains('is-open');

          if (isOpen) {
            this.closeAccordion(accordion);
          } else {
            this.openAccordion(accordion);
          }
        });
      });
    }

    setupAccordions() {
      this.accordions.forEach((accordion) => {
        const panel = accordion.querySelector('[data-careers-accordion-panel]');
        const toggle = accordion.querySelector('[data-careers-accordion-toggle]');

        if (!panel || !toggle) return;

        if (!this.mobileMedia.matches) {
          panel.style.maxHeight = '';
          toggle.setAttribute('aria-expanded', 'true');
          return;
        }

        if (accordion.classList.contains('is-open')) {
          this.setPanelHeight(panel);
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          panel.style.maxHeight = '0px';
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    setPanelHeight(panel) {
      if (!panel) return;

      panel.style.maxHeight = 'none';

      const panelHeight = panel.scrollHeight;

      panel.style.maxHeight = `${panelHeight + 8}px`;
    }

    refreshOpenAccordions() {
      if (!this.mobileMedia.matches) return;

      window.requestAnimationFrame(() => {
        this.accordions.forEach((accordion) => {
          if (!accordion.classList.contains('is-open')) return;

          const panel = accordion.querySelector('[data-careers-accordion-panel]');
          const toggle = accordion.querySelector('[data-careers-accordion-toggle]');

          if (!panel || !toggle) return;

          this.setPanelHeight(panel);
          toggle.setAttribute('aria-expanded', 'true');
        });
      });
    }

    openAccordion(accordion) {
      const panel = accordion.querySelector('[data-careers-accordion-panel]');
      const toggle = accordion.querySelector('[data-careers-accordion-toggle]');

      if (!panel || !toggle) return;

      accordion.classList.add('is-open');
      this.setPanelHeight(panel);
      toggle.setAttribute('aria-expanded', 'true');
    }

    closeAccordion(accordion) {
      const panel = accordion.querySelector('[data-careers-accordion-panel]');
      const toggle = accordion.querySelector('[data-careers-accordion-toggle]');

      if (!panel || !toggle) return;

      accordion.classList.remove('is-open');
      panel.style.maxHeight = '0px';
      toggle.setAttribute('aria-expanded', 'false');
    }

    handleResize() {
      clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        this.refreshOpenAccordions();
      }, 120);
    }

    handleMediaChange() {
      this.setupAccordions();
      this.refreshOpenAccordions();
    }
  }

  const initCareersOpenRoles = (container = document) => {
    const sections = container.querySelectorAll('[data-careers-open-roles]');

    sections.forEach((section) => {
      if (section.dataset.careersOpenRolesInitialized === 'true') return;

      section.dataset.careersOpenRolesInitialized = 'true';
      new CareersOpenRoles(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initCareersOpenRoles();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initCareersOpenRoles(event.target);
  });
})();